import type { MinigameDefinition } from '@core/types';
import { RhythmConfig } from '@modules/rhythm/config';
import { RhythmScene } from '@modules/rhythm/RhythmScene';

/** Definicion publica del modulo de ritmo para registrarlo en el catalogo. */
export const rhythmMinigame: MinigameDefinition = {
  key: RhythmConfig.key,
  title: RhythmConfig.title,
  description: RhythmConfig.description,
  icon: RhythmConfig.icon,
  color: RhythmConfig.color,
  scene: RhythmScene,
};
